export default __webpack_public_path__ + "static/Etiqa-EGTB-dd61333fcc65d7d78e413146192d008c.png";